import type { SignatureStatus } from "@/api/db/connection";

import { OperacaoLabels } from "./operacao";

const errorByCode: Record<string, string> = {
	PERSON_NOT_FOUND: "Essa pessoa não existe mais.",
	MISSING_NAME: "O cadastro precisa do nome completo da paciente.",
	MISSING_CPF: "O cadastro precisa de um CPF válido.",
	MISSING_PHONE: "O cadastro precisa de um celular brasileiro.",
	TERM_NOT_FOUND: "Um dos termos selecionados não existe mais.",
	TERM_REVIEW_REQUIRED: "Termo incompleto sem revisão salva.",
	UNRESOLVED_FIELD: "Um campo do termo não pôde ser preenchido com os dados do cadastro.",
	MISSING_CUSTOM_FIELD: "Campos obrigatórios do termo sem valor.",
	INVALID_CUSTOM_FIELD: "Um campo do termo contém um valor inválido.",
	MISSING_PATTERN_ITEM: "Lista obrigatória do termo sem itens.",
	SEND_DISABLED: "Os envios reais estão desativados neste ambiente.",
	INVALID_STATE: "Esse envio não está mais pendente.",
	AI_UNAVAILABLE: "A IA não conseguiu responder agora.",
	NOT_FOUND: "Esse envio não existe mais.",
	CLICKSIGN_ERROR: "A Clicksign não aceitou a operação.",
};

const statusLabel: Record<SignatureStatus, string> = {
	sent: "Aguardando assinatura",
	signed: "Assinado",
	refused: "Recusado",
	canceled: "Cancelado",
	expired: "Expirado",
};

const recipientIssue: Record<string, string> = {
	MISSING_NAME: "Nome completo ausente",
	MISSING_CPF: "CPF válido ausente",
	MISSING_PHONE: "Celular brasileiro ausente",
};

export const DocumentosLabels = {
	title: "Assinaturas",

	empty: {
		title: "Nenhum termo enviado",
	},
	loadError: "Não foi possível carregar os envios.",

	send: "Novo envio",
	sendTitle: "Preparar envio para assinatura",
	sendTerms: "Termos",
	sendNoTerms: "Nenhum modelo disponível na área Termos da Clínica.",
	sendReviewRequired: "Revisão pendente",
	sendFields: "Dados do documento",
	sendDeadline: "Prazo da assinatura",
	sendConfirm: "Enviar para assinatura",
	sending: "Enviando para assinatura...",
	sentToast: "Termos enviados para assinatura.",
	cancelAction: "Cancelar envio",
	cancelPrompt: "Cancelar este envio?",
	canceledToast: "Envio cancelado.",
	resendAction: "Reenviar notificação",
	resentToast: "Notificação reenviada.",
	downloadSigned: "Ver assinado",

	preparation: {
		recipient: "Paciente",
		recipientReady: "Dados completos",
		recipientBlocked: "Envio bloqueado",
		name: "Nome",
		cpf: "CPF",
		phone: "Celular",
		missingValue: "Não informado",
		openRegistration: "Abrir cadastro",
		selectedTerms: "Documentos do envio",
		selectTerm: "Documentos disponíveis",
		noSelection: "Nenhum documento selecionado",
		automaticFields: "Dados automáticos do cadastro",
		preview: "Prévia do documento",
		previewEmpty: "Nenhum documento selecionado.",
		previewUnavailable: "Este termo ainda não está pronto para visualização.",
		deadlineSuffix: "dias",
		documentsWaiting: "Documentos aguardando dados",
		assistantSelectTerms: "Nenhum documento no envio.",
		assistantReady: "Campos disponíveis para ajuste.",
		assistantPlaceholder: "Ajuste nos dados dos documentos",
		askAssistant: "Pedir ajuste",
		assistantWorking: "Conferindo os campos...",
		assistantUnavailable:
			"Não consegui analisar esse pedido agora. Os campos continuam como estavam.",
		adjustmentsStale: "Os campos mudaram depois da proposta. A proposta foi descartada.",

		adjustmentsApplied(total: number) {
			return total === 1 ? "O ajuste foi aplicado." : `${total} ajustes foram aplicados.`;
		},

		adjustmentsProposed(total: number) {
			return total === 1 ? "1 ajuste proposto." : `${total} ajustes propostos.`;
		},

		recipientIssue(code: string) {
			return recipientIssue[code] ?? code;
		},

		fieldProgress(filled: number, total: number) {
			return `${filled} de ${total} campos preenchidos`;
		},

		missingFields(total: number) {
			return total === 1 ? "1 campo sem valor" : `${total} campos sem valor`;
		},

		documentCount(total: number) {
			return total === 1 ? "1 documento" : `${total} documentos`;
		},
	},

	status: statusLabel,

	sentAt(iso: Date | string) {
		return `Enviado ${OperacaoLabels.moment(iso)}`;
	},

	deadline(iso: string) {
		return `Prazo até ${new Date(iso).toLocaleDateString("pt-BR")}`;
	},

	error(code: string | undefined) {
		if (code === undefined) {
			return "Não foi possível concluir a operação.";
		}

		return errorByCode[code] ?? "Não foi possível concluir a operação.";
	},
};
